"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CryptoboxError_1 = require("./CryptoboxError");
exports.CryptoboxError = CryptoboxError_1.default;
//# sourceMappingURL=root.js.map


//////////////////
// WEBPACK FOOTER
// ./dist/commonjs/error/root.js
// module id = 105
// module chunks = 0 1